import { AppDispatch } from '@store/index';

export const screenResize =
    (screenWidth: number) => (dispatch: AppDispatch) => {
        dispatch({
            type: 'SCREEN_RESIZE',
            payload: screenWidth,
        });
    };
